import { AnalyticManager, } from "./manager";
import { storeKey } from "./vars";
const AnalyticManagerPlugin = {
    install: (app, options) => {
        if (options?.config) {
            AnalyticManager.config(options?.config);
        }
        if (options?.events) {
            AnalyticManager.events(options?.events);
        }
        if (options?.globalParams) {
            AnalyticManager.globalParams(options?.globalParams);
        }
        app.provide(storeKey, AnalyticManager);
    },
};
export default AnalyticManagerPlugin;
